import React, { Component } from "react";
import EditorActions from "../../Shared/Edit/EditorActions";
import Loader from "../../Shared/Loader/loader";
import { Checkbox, NumericTextBox } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import NumberField from "../Fields/NumberField";
import DateTimeTypeField from "../Fields/DateTimeTypeField";
import { TimePickerComponent } from "@syncfusion/ej2-react-calendars";
import NumberTypeField from "../Fields/NumberTypeField";
import { PicklistOptionsField } from "../Fields/PicklistStringFields";
import AttributeTypeField from "../Fields/AttributeTypeField";
import Scrollable from "../../Shared/Edit/Scrollable";
import ErrorMessage from "../../Shared/Error/ErrorMessage";
import { OverlayLoader } from "../../Shared/Loader/OverlayLoader";
import NumericInput from "../Fields/NumericInput";
import { withTranslation } from "react-i18next";
import { StateFeildOptionsField } from "../Fields/StateFields";
import { updateAttributeTemplate } from "../../../API/AttributeTemplate/AttributeTemplate";
import { uuidv4 } from "../Fields/TreeDropdownHelper";

class LookupSidebar extends Component {
	saveButton = React.createRef();
	defaultData = {};
	interval = ["1", "5", "10", "15", "30"];

	constructor(props) {
		super(props)
		this.state = {
			loading: false,
			disabled: true,
			nameExists: false,
			nameError: {
				isValid: true,
				message: ""
			},
			showAdditionalFields: true,
			isDescriptionFocus: false,
			LookupName: "",
			lookupType: "",
			description: "",
			min: "",
			max: "",
			pattern: "",
			decimalPlace: "0",
			unit: "none",
			useThousandSeparator: false,
			unitSide: "Right",
			errors: {
				isMinValid: true,
				isMaxValid: true,
				minError: "",
				maxError: "",
			},
			dateError: {
				isDefaultValueValid: true,
				defaultValueError: "",
			},
			timeError: {
				isMinValid: true,
				isMaxValid: true,
				isDefaultValueValid: true,
				minError: "",
				maxError: "",
			},
			statefieldError: {
				isValid: true,
				message: "",
			},
			statefield: [],
			isPatternValid: true,
			isPicklistProper: true,
			isPicklistEmpty: false,
			savingAttributeTemplate: false,
			showInIframe: this.props.showInIframe
		};
	}

	componentDidUpdate = (props) => {
		if (this.props.selectedAttribute._id !== props.selectedAttribute._id) {
			let data = {};
			data.LookupName = this.props.selectedAttribute.LookupName;
			data.lookupType = this.props.selectedAttribute.lookupType;
			data.typeText = this.props.selectedAttribute.typeText;
			data.description = this.props.selectedAttribute.description;
			data._id = this.props.selectedAttribute._id;

			if (this.props.selectedAttribute.lookupType === "Picklist String") {
				data.picklist = this.props.selectedAttribute.picklist;
				data.multiSelect = this.props.selectedAttribute.multiSelect;
			}
			if (this.props.selectedAttribute.lookupType === "String") {
				data.min = parseInt(this.props.selectedAttribute.min) || "";
				data.max = parseInt(this.props.selectedAttribute.max) || "";
				data.pattern = this.props.selectedAttribute.pattern;
			}
			if (this.props.selectedAttribute.lookupType === "Number") {
				data.min = parseInt(this.props.selectedAttribute.min) || "";
				data.max = parseInt(this.props.selectedAttribute.max) || "";
				data.numberType = this.props.selectedAttribute.numberType;
				data.decimalPlace = this.props.selectedAttribute.decimalPlace;
				data.unit = this.props.selectedAttribute.unit.replace(/\\\"/, '"');
				data.useThousandSeparator = this.props.selectedAttribute.useThousandSeparator === "true" ? true : false;
				data.unitSide = this.props.selectedAttribute.unitSide;
			}

			if (this.props.selectedAttribute.lookupType === "User Identity") {
				data.showProfilePicture = this.props.selectedAttribute.showProfilePicture;
				data.useDisplayName = this.props.selectedAttribute.useDisplayName;
				data.multiSelect = this.props.selectedAttribute.multiSelect;
			}

			if (this.props.selectedAttribute.lookupType === "DateTime") {
				data.dateTimeType = this.props.selectedAttribute.dateTimeType;
				if (data.dateTimeType === "date") {
					data.setDefaultDate = this.props.selectedAttribute.setDefaultDate === "true" ? true : false;
					data.defaultDate = this.props.selectedAttribute.defaultDate;
				}
				if (data.dateTimeType === "time") {
					data.interval = this.props.selectedAttribute.interval;
					data.minTime = this.props.selectedAttribute.minTime || "";
					data.maxTime = this.props.selectedAttribute.maxTime || "";
					data.defaultTime = this.props.selectedAttribute.defaultTime || "";
				}
				if (data.dateTimeType === "datetime") {
					data.setDefaultDate = this.props.selectedAttribute.setDefaultDate === "true" ? true : false;
					data.defaultDate = this.props.selectedAttribute.defaultDate;
					data.interval = this.props.selectedAttribute.interval;
					data.minTime = this.props.selectedAttribute.minTime || "";
					data.maxTime = this.props.selectedAttribute.maxTime || "";
					data.defaultTime = this.props.selectedAttribute.defaultTime || "";
				}
			}

			if (this.props.selectedAttribute.lookupType === "State Field") {
				data.statefield = this.props.selectedAttribute.statefield;
			}
			this.defaultData = data;

			const newState = {
				...data,
				disabled: true,
				nameExists: false,
				nameError: {
					isValid: true,
					message: ""
				},
				errors: {
					isMinValid: true,
					isMaxValid: true,
					minError: "",
					maxError: "",
				},
				isPicklistProper: true,
				isPatternValid: true,
				isPicklistEmpty: false,
				statefieldError: {
					isValid: true,
					message: "",
				}
			};
			this.setState(newState);
		}
	}

	hasErrors = (e) => {
		let errors = !this.state.disabled
		if (
			this.state.isPatternValid === false ||
			this.state.nameError.isValid === false ||
			this.state.dateError.isDefaultValueValid === false ||
			this.state.timeError.isDefaultValueValid === false ||
			this.state.timeError.isMinValid === false ||
			this.state.errors.isMaxValid === false ||
			this.state.errors.isMinValid === false ||
			this.state.statefieldError.isValid === false
		) {
			errors = true
		}
		return errors
	}

	render() {
		const { t } = this.props;

		if (this.state.loading) {
			return <Loader />;
		}

		var AdditionalData;

		if (this.state.lookupType === "Picklist String") {
			AdditionalData = [
				<>
					<div className="me-1 form-label d-inline-block">
						<span required>
							{t("fields.dropdown_values")}
						</span>
					</div>
					{
						this.state.isPicklistEmpty &&
						<span className="mx-1 error" >
							{t("errors.dropdown_values_required")}
						</span>
					}
					{
						!this.state.isPicklistEmpty &&
						<span className="mx-1 error">{this.state.isPicklistProper === false && t("errors.dropdown_values_duplicate")}</span>
					}

					<PicklistOptionsField
						addDropdownButtonText={t("buttons.add_dropdown_value")}
						onChange={this.handleDropdownChange}
						value={this.state.picklist} onErr={(e) => {
							this.setState({
								isPicklistProper: e.length < 0
							})
						}}
						autoFocus={true}
					/>
					<div className="py-2">
						<Checkbox
							checked={this.state.multiSelect}
							label={t("fields.multiple_selection")}
							onChange={this.handleMultiSelect}
						/>
					</div>
				</>,
			];
		}

		if (this.state.lookupType === "String") {
			AdditionalData = [
				<>
					<div className="me-1 form-label d-inline-block">
						{t("fields.minimum_length")}
					</div>
					<span className="error">{!this.state.errors.isMinValid && this.state.errors.minError}</span>
					<NumericTextBox
						className="form-control-custom blue-focus"
						name="min"
						format="n0"
						spinners={false}
						value={this.state.min}
						onChange={this.handleMinLength}
						step={1}
					/>
					<div className="me-1 form-label d-inline-block">
						{t("fields.maximum_length")}
					</div>
					<span className="mx-1 error">{!this.state.errors.isMaxValid && this.state.errors.maxError}</span>
					<NumericTextBox
						className="form-control-custom blue-focus"
						name="max"
						format="n0"
						spinners={false}
						value={this.state.max}
						onChange={this.handleMaxlength}
						step={1}
					/>
					<div className="me-1 form-label d-inline-block">
						{t("fields.pattern")}
					</div>
					<span className="mx-1 error">{!this.state.isPatternValid && "Invalid Pattern"}</span>
					<input value={this.state.pattern} className="form-control" type="text" onChange={this.handlePattern} />
				</>,
			];
		}

		if (this.state.lookupType === "User Identity") {
			AdditionalData = [
				<>
					<div className="py-2">
						<Checkbox
							checked={this.state.showProfilePicture}
							label={t("fields.show_profile_picture")}
							onChange={this.handleShowProfilePicture}
						/>
					</div>
					<div className="py-2">
						<Checkbox
							checked={this.state.useDisplayName}
							label={t("fields.use_display_name")}
							onChange={this.handleUseDisplayName}
						/>
					</div>
					<div className="py-2">
						<Checkbox
							checked={this.state.multiSelect}
							label={t("fields.multiple_selection")}
							onChange={this.handleMultiSelect}
						/>
					</div>
				</>,
			];
		}

		if (this.state.lookupType === "Number") {
			AdditionalData = [
				<>
					<NumberField numberType={this.state.numberType} decimalPlace={this.state.decimalPlace} useThousandSeparator={this.state.useThousandSeparator} unit={this.state.unit} unitSide={this.state.unitSide} onChange={this.handleNumberField} />
					<div className="me-1 form-label d-inline-block">
						{t("fields.minimum_value")}
					</div>
					<span className="error">{!this.state.errors.isMinValid && this.state.errors.minError}</span>
					<NumericInput
						className="form-control"
						name="min"
						format={this.state.numberType === "integer" ? "n0" : "n" + this.state.decimalPlace}
						value={this.state.min}
						onChange={this.handleMinValue}
						maxLength={10}
					/>
					<div className="me-1 form-label d-inline-block">
						{t("fields.maximum_value")}
					</div>
					<span className="mx-1 error">{!this.state.errors.isMaxValid && this.state.errors.maxError}</span>
					<NumericInput
						className="form-control"
						name="max"
						format={this.state.numberType === "integer" ? "n0" : "n" + this.state.decimalPlace}
						value={this.state.max}
						onChange={this.handleMaxValue}
						maxLength={10}
					/>
				</>,
			];
		}

		if (this.state.lookupType === "DateTime") {
			if (this.state.dateTimeType === "date") {
				AdditionalData = [
					// <div className="py-3">
					// 	<Checkbox onChange={this.handleDefaultDateCheckbox} name="setDefaultDate" checked={this.state.setDefaultDate} label="Default Date" />
					// 	&nbsp;
					// 	{this.state.dateError.isDefaultValueValid ? null : <span className="error d-block">{this.state.dateError.defaultValueError}</span>}
					// 	{this.state.setDefaultDate && <RelativeDateField value={this.state.defaultDate} onChangeSign={this.handleDateChange} onChangeType={this.handleDateChange} onChangeValue={this.handleDateChange} visible={this.state.setDefaultDate} />}
					// </div>
				];
			}
			if (this.state.dateTimeType === "time") {
				AdditionalData = [
					<>
						{/* <div className="me-2 form-label d-inline-block">Default Time</div>
						<span className="error d-inline-block">{this.state.timeError.defaultValueError}</span>
						<TimePickerComponent
							format={'h:mm aa'}
							strictMode={true}
							openOnFocus={true}
							showClearButton={false}
							key={this.props.selectedAttribute._id}
							name="defaultTime"
							value={this.state.defaultTime}
							change={this.handleDefaultTime}
						/> */}

						<div className="form-label">
							{t("fields.internal_in_minutes")}
						</div>
						<DropDownList className="w-100" data={this.interval} onChange={this.handleInterval} value={this.state.interval} />

						<div className="m-0 row no-gutters ">
							<div className="col-12 m-0 p-0">
								<div className="me-2 form-label d-inline-block">
									{t("fields.earliest_time")}
								</div>
								<span className="error d-inline-block">{this.state.timeError.minError}</span>
								<TimePickerComponent
									format={'h:mm aa'}
									strictMode={true}
									openOnFocus={true}
									showClearButton={false}
									key={this.props.selectedAttribute._id}
									name="minTime"
									value={this.state.minTime}
									change={this.handleMinTime}
								/>
							</div>
							<div className="col-12 m-0 p-0">
								<div className="me-2 form-label d-inline-block">
									{t("fields.latest_time")}
								</div>
								<span className="error d-inline-block">{this.state.timeError.maxError}</span>
								<TimePickerComponent
									format={'h:mm aa'}
									strictMode={true}
									openOnFocus={true}
									showClearButton={false}
									key={this.props.selectedAttribute._id}
									name="maxTime"
									value={this.state.maxTime}
									change={this.handleMaxTime}
								/>
							</div>
						</div>
					</>
				];
			}

			if (this.state.dateTimeType === "datetime") {
				AdditionalData = [
					<div div className="py-3">
						{/* <Checkbox onChange={this.handleDefaultDateCheckbox} name="setDefaultDate" checked={this.state.setDefaultDate} label="Default Date" />
						&nbsp;
						{this.state.dateError.isDefaultValueValid ? null : <span className="error d-block">{this.state.dateError.defaultValueError}</span>}
						{this.state.setDefaultDate ? (
							<>
								<RelativeDateField value={this.state.defaultDate} onChangeSign={this.handleDateChange} onChangeType={this.handleDateChange} onChangeValue={this.handleDateChange} visible={this.state.setDefaultDate} />
								<div className="form-label d-inline-block">Default Time</div>
								<span className="text-danger ms-2  d-inline-block">{this.state.timeError.defaultValueError}</span>
								<TimePickerComponent
									format={'h:mm aa'}
									strictMode={true}
									openOnFocus={true}
									showClearButton={false}
									key={this.props.selectedAttribute._id}
									name="defaultTime"
									value={this.state.defaultTime}
									change={this.handleDefaultTime}
								/>
							</>
						) : (
							<br />
						)} */}
						<div className="form-label">
							{t("fields.internal_in_minutes")}
						</div>
						<DropDownList className="w-100" data={this.interval} onChange={this.handleInterval} value={this.state.interval} />
						<div className="m-0 row no-gutters ">
							<div className="col-12 m-0 p-0">
								<div className="form-label d-inline-block">
									{t("fields.earliest_time")}
								</div>
								<span className="text-danger ms-2 d-inline-block">{this.state.timeError.minError}</span>
								<TimePickerComponent
									format={'h:mm aa'}
									strictMode={true}
									openOnFocus={true}
									showClearButton={false}
									key={this.props.selectedAttribute._id}
									name="minTime"
									value={this.state.minTime}
									change={this.handleMinTime}
								/>
							</div>
							<div className="col-12 m-0 p-0">
								<div className="form-label d-inline-block">
									{t("fields.latest_time")}
								</div>
								<span className="text-danger ms-2 d-inline-block">{this.state.timeError.maxError}</span>
								<TimePickerComponent
									format={'h:mm aa'}
									strictMode={true}
									openOnFocus={true}
									showClearButton={false}
									key={this.props.selectedAttribute._id}
									name="maxTime"
									value={this.state.maxTime}
									change={this.handleMaxTime} />
							</div>
						</div>
					</div>,
				];
			}
		}

		if (this.state.lookupType === "State Field") {
			AdditionalData = [
				<>
					<div className="form-label d-inline-block" required>
						{t("fields.state_field")}
					</div>
					<ErrorMessage
						visible={!this.state.statefieldError.isValid}
						error={this.state.statefieldError.message}
					/>
					<StateFeildOptionsField
						showLanguageTranslation={true}
						key={this.props.selectedAttribute._id}
						onChange={this.handleStateFieldChange}
						value={this.state.statefield}
						onErr={(err) => { this.setStateFieldError(err) }}
						showColorPicker={true}
						TooltipPosition={'left'}
					/>
				</>
			]
		}

		return (
			<div className="h-100">
				{
					this.state.savingAttributeTemplate &&
					<OverlayLoader />
				}
				< div className="d-flex flex-column h-100" >
					<div>
						<EditorActions
							header={t("header.title")}
							redoClicked={this.setDefault}
							active={this.state.disabled}
							hasErrors={this.hasErrors()}
							saving={this.state.savingAttributeTemplate}
							saveClicked={this.handleSubmit}
							deleteClicked={this.handleDelete}
							ShowMoreButtons={false}
						/>
					</div>
					<Scrollable>
						<div className={this.props.showInIframe ? "checkRuntimeUser" : ""}>
							<div className="py-1">
								<div className="form-label d-inline-block" required>
									{t("fields.name")}
								</div>
								<ErrorMessage
									valid={this.state.nameError.isValid}
									error={this.state.nameError.message}
								/>
								<input maxLength={64} className={"form-control name-text font-weight-bold"} name="attributeName" value={this.state.LookupName} onChange={this.handleName} />
							</div>

							<div className="py-1 w-50">
								<div className="form-label">
									{t("fields.type")}
								</div>
							</div>
							<div className="d-flex fontUrl">
								<div className="w-50"><AttributeTypeField attributeType={this.state.lookupType} /></div>
							</div>
							<div className="mt-3">
								{this.state.lookupType === "DateTime" && <DateTimeTypeField value={this.state.dateTimeType} disabled={true} />}
								{this.state.lookupType === "Number" && <NumberTypeField value={this.state.numberType} disabled={true} />}
							</div>

							{this.state.showAdditionalFields && (
								<>
									{AdditionalData}
									<div className="my-2">
										<div className="form-label">
											{t("fields.description")}
										</div>
										<textarea
											className="w-100 form-control"
											rows={this.state.isDescriptionFocus ? "4" : "1"}
											value={this.state.description}
											onFocus={this.handleDescriptionFocus}
											onBlur={this.handlebDescriptionblur}
											onChange={this.handleDescription}
										></textarea>
									</div>
								</>
							)}
							{/* <div className="mt-2">
								<ShowMore toggled={(o) => this.toggleFields(o)}></ShowMore>
							</div> */}
						</div>
					</Scrollable>
				</div >
			</div>
		);
	}

	getDisabled() {
		return this.state.disabled;
	}

	cancel = () => {
		this.setState({ disabled: true });
	};

	//handle

	// toggleFields = () => {
	// 	this.setState({
	// 		showAdditionalFields: !this.state.showAdditionalFields,
	// 	});
	// };

	handleName = (e) => {
		let { nameError } = this.state
		const { t } = this.props;
		let { value } = e.target
		const nameIsBlank = value.trim() === ""
		const nameIsReserved = value.toLowerCase().replace(/[^a-zA-Z0-9]/g, "").trim() === "id"
		const nameInUse = this.props.LookupData.findIndex((lookup) => lookup.LookupName.toLowerCase() === e.target.value.toLowerCase() && lookup._id !== this.props.selectedAttribute._id) >= 0;
		const nameContainsSys = /^\[SYS\]/i.test(value.trim());
		const nameStartWithNumber = value.trim().match(/^\d/)
		const hasSpecialCharacters = /[\\"'\/]/.test(value.trim());
		if (nameIsBlank) {
			nameError.isValid = false
			nameError.message = t("errors.name_required")
		} else if (nameStartWithNumber) {
			nameError.isValid = false
			nameError.message = t("errors.name_starts_with_number")
		} else if (nameInUse) {
			nameError.isValid = false
			nameError.message = t("errors.name_in_use")
		} else if (nameContainsSys) {
			nameError.isValid = false
			nameError.message = t("errors.name_contains_sys")
		} else if (hasSpecialCharacters) {
			nameError.isValid = false
			nameError.message = t("errors.name_contain_specical_character")
		} else if (nameIsReserved) {
			nameError.isValid = false
			nameError.message = t("errors.name_is_reserved")
		} else {
			nameError.isValid = true
			nameError.message = "";
		}

		this.setState({
			lookupName: e.target.value,
			nameError: nameError
		});
		this.setState(
			{
				LookupName: e.target.value,
				nameError: nameError
			},
			() => {
				this.setDisabled();
			}
		);
	};

	handleMultiSelect = (e) => {
		this.setState(
			{
				multiSelect: e.value,
			},
			() => {
				this.setDisabled();
			}
		);
	};

	handleShowProfilePicture = (e) => {
		this.setState(
			{
				showProfilePicture: e.value,
			},
			() => {
				this.setDisabled();
			}
		);
	};

	handleUseDisplayName = (e) => {
		this.setState(
			{
				useDisplayName: e.value,
			},
			() => {
				this.setDisabled();
			}
		);
	};

	handleNumberField = (e) => {
		let { format, decimalPlace, unitSide } = this.state;
		let { name, value } = e.target;
		if (name === "decimalPlace") {
			format = "n";
			format += value;
		}
		if (name === "unit") {
			if (value === "none") {
				decimalPlace = "2";
				format = "undefined";
				unitSide = this.defaultData.unitSide;
			} else {
				decimalPlace = "2";
				format = "n2";
			}
			this.setState({
				decimalPlace,
				unitSide
			});
		}

		this.setState({ [name]: value, format }, () => {
			this.setDisabled();
		});
	};

	handleMinLength = (e) => {
		const { value } = e.target;
		const { max } = this.state;
		const errors = this.findMinMaxLengthErrors(value, max);

		this.setState(
			{
				min: value,
				errors,
			},
			() => {
				this.setDisabled();
			}
		);
	};

	handleMaxlength = (e) => {
		const { value } = e.target;
		const { min } = this.state;
		const errors = this.findMinMaxLengthErrors(min, value);
		this.setState(
			{
				max: value,
				errors,
			},
			() => {
				this.setDisabled();
			}
		);
	};

	handleMinValue = (e) => {
		const { value } = e.target;
		const { max } = this.state;
		const errors = this.findMinMaxValueErrors(value, max);
		this.setState(
			{
				min: value,
				errors,
			},
			() => {
				this.setDisabled();
			}
		);
	};

	handleMaxValue = (e) => {
		const { value } = e.target;
		const { min } = this.state;
		const errors = this.findMinMaxValueErrors(min, value);
		this.setState(
			{
				max: value,
				errors,
			},
			() => {
				this.setDisabled();
			}
		);
	};

	handlePattern = (e) => {
		let regex = new RegExp("^[09#LAa&()C-]+$");
		let valid = regex.test(e.target.value);

		this.setState(
			{
				isPatternValid: e.target.value === "" ? true : valid,
				pattern: e.target.value,
			},
			() => {
				this.setDisabled();
			}
		);
	};

	findMinMaxLengthErrors = (min, max) => {

		const errors = {
			isMinValid: true,
			isMaxValid: true,
			minError: "",
			maxError: "",
		};

		const minValue = parseInt(min);
		const maxValue = parseInt(max);

		if (errors.isMinValid && minValue < 1) {
			errors.isMinValid = false;
			errors.minError = "Minimum length cannot be negative or zero";
		}

		if (errors.isMaxValid && maxValue < 1) {
			errors.isMaxValid = false;
			errors.maxError = "Maximum length cannot be negative or zero";
		}

		if (errors.isMaxValid && maxValue > 256) {
			errors.isMaxValid = false;
			errors.maxError = "Maximum length cannot exceed 256";
		}

		if (errors.isMaxValid && errors.isMinValid && minValue > maxValue) {
			errors.isMinValid = false;
			errors.minError = "Min length cannot exceed max length";
		}

		return errors;
	};

	findMinMaxValueErrors = (min, max) => {
		const errors = {
			isMinValid: true,
			isMaxValid: true,
			minError: "",
			maxError: "",
		};

		const minValue = parseInt(min);
		const maxValue = parseInt(max);

		if (minValue > 2147483647) {
			errors.isMinValid = false;
			errors.minError = "Min value must not be bigger than 2,147,483,647";
		}
		if (maxValue > 2147483647) {
			errors.isMaxValid = false;
			errors.maxError = "Max value must not be bigger than 2,147,483,647";
		}

		if (errors.isMaxValid && errors.isMinValid && minValue > maxValue) {
			errors.isMinValid = false;
			errors.minError = "Min value cannot exceed max value";
		}

		return errors;
	}

	setStateFieldError = (err) => {
		const { statefieldError } = this.state;
		if (err.lengt > 0) {
			statefieldError.isValid = false;
		} else {
			statefieldError.isValid = true;
		}
		statefieldError.message = err;
		this.setState(statefieldError);
	};

	handleStateFieldChange = (data) => {
		const { t } = this.props;
		const isStatefieldDuplicated = this.checkStateFieldIsDuplicated(data);
		const { statefieldError } = this.state;
		if (isStatefieldDuplicated) {
			statefieldError.isValid = false;
			statefieldError.message = t("errors.duplicate_state_field");
		} else {
			statefieldError.isValid = true;
			statefieldError.message = "";
		}
		this.setState({
			statefield: data,
			statefieldError: statefieldError
		}, () => {
			this.setDisabled();
		})
	}

	checkStateFieldIsDuplicated = (data) => {
		const statefieldValues = data.map((option) => option.name);
		const statefieldValuesMap = {};
		let isStatefieldDuplicated = false;

		for (const value of statefieldValues) {
			statefieldValuesMap[value] = statefieldValuesMap[value] ? ++statefieldValuesMap[value] : 1;
			if (statefieldValuesMap[value] > 1) {
				isStatefieldDuplicated = true;
				break;
			}
		}

		return isStatefieldDuplicated;
	}

	handlePicklist = (e) => {
		var ePicklistData = "";
		var listData = e.target.value.split("\n");
		if (listData[listData.length - 1] === "") {
			listData.splice(listData.length - 1, 1);
		}
		this.setState(
			{
				picklist: e.target.value,
				CommaPicklist: listData.join(),
			},
			() => {
				this.setDisabled();
			}
		);
	};

	handleDropdownChange = (e) => {
		let isPicklistProper = this.isPicklistProper(e.target.value);
		this.setState(
			{
				picklist: e.target.value,
				isPicklistProper: isPicklistProper,
				isPicklistEmpty: e.target.value === "" ? true : false
			},
			() => {
				this.setDisabled();
			}
		);
	};

	isPicklistProper = (data) => {
		const picklistValues = data
			.split("ɖ")
			.filter((option) => option.trim() !== "")
			.map((option) => option.trim());
		const picklistValuesMap = {};
		let isPicklistValid = true;

		if (picklistValues.length === 0) return false;

		for (const value of picklistValues) {
			picklistValuesMap[value] = picklistValuesMap[value] ? ++picklistValuesMap[value] : 1;
			if (picklistValuesMap[value] > 1) {
				isPicklistValid = false;
				break;
			}
		}
		return isPicklistValid;
	};

	handleDefaultDateCheckbox = (e) => {
		let { defaultDate } = this.state;
		if (!e.value) {
			defaultDate = "";
		} else {
			defaultDate = "Today_+_0_Days";
		}
		this.setState(
			{
				setDefaultDate: e.value,
				defaultDate,
			},
			() => {
				this.setDisabled();
			}
		);
	};

	handleDateChange = (e) => {
		this.setState(
			{
				defaultDate: e.target.value,
			},
			() => {
				this.setDisabled();
			}
		);
	};

	handleMinTime = (e) => {
		const { text } = e;
		let { minTime, maxTime, defaultTime } = this.state;
		minTime = text;
		const timeError = this.findErrorsInTimeConfiguration(minTime, maxTime, defaultTime);
		this.setState(
			{
				minTime,
				timeError,
			},
			() => {
				this.setDisabled();
			}
		);
	};

	handleMaxTime = (e) => {
		const { text } = e;
		let { minTime, maxTime, defaultTime } = this.state;
		maxTime = text;
		const timeError = this.findErrorsInTimeConfiguration(minTime, maxTime, defaultTime);
		this.setState(
			{
				maxTime,
				timeError,
			},
			() => {
				this.setDisabled();
			}
		);
	};

	handleDefaultTime = (e) => {
		const { text } = e;
		let { minTime, maxTime, defaultTime } = this.state;
		defaultTime = text;
		const timeError = this.findErrorsInTimeConfiguration(minTime, maxTime, defaultTime);
		this.setState(
			{
				defaultTime,
				timeError,
			},
			() => {
				this.setDisabled();
			}
		);
	};

	findErrorsInTimeConfiguration = (minTime, maxTime, defaultTime) => {
		const { timeError } = this.state;
		// let min, max, DefaultTime

		let min = minTime;
		let max = maxTime;
		let DefaultTime = defaultTime

		if (min !== "") {
			min = new Date('2020-01-01 ' + minTime);
		}
		if (max !== "") {
			max = new Date('2020-01-01 ' + maxTime);
		}
		if (defaultTime !== "") {
			DefaultTime = new Date('2020-01-01 ' + defaultTime)
		}

		if (min && max && min > max) {
			timeError.isMinValid = false;
			timeError.minError = "Earliest time cannot be later than latest time";
		} else {
			timeError.isMinValid = true;
			timeError.minError = "";
		}

		if (defaultTime === "") {
			timeError.isDefaultValueValid = false;
			timeError.defaultValueError = "Default time cannot be blank";
		} else if (DefaultTime && min && DefaultTime < min) {
			timeError.isDefaultValueValid = false;
			timeError.defaultValueError = "Default time cannot be earlier than earliest time";
		} else if (DefaultTime && max && DefaultTime > max) {
			timeError.isDefaultValueValid = false;
			timeError.defaultValueError = "Default time cannot be later than latest time";
		} else {
			timeError.isDefaultValueValid = true;
			timeError.defaultValueError = "";
		}
		return timeError;
	};

	handleInterval = (e) => {
		this.setState(
			{
				interval: e.target.value,
			},
			() => {
				this.setDisabled();
			}
		);
	};

	handleDescription = (e) => {
		this.setState(
			{
				description: e.target.value,
			},
			() => {
				this.setDisabled();
			}
		);
	};

	handleDescriptionFocus = () => {
		this.setState({
			isDescriptionFocus: !this.state.isDescriptionFocus,
		});
	};

	handlebDescriptionblur = () => {
		this.setState({
			isDescriptionFocus: !this.state.isDescriptionFocus,
		});
	};

	handleDelete = (e) => {
		//e.preventDefault();
		this.props.Delete(this.props.selectedAttribute._id);
	};

	setDisabled = () => {
		let condition =
			this.defaultData.LookupName !== this.state.LookupName ||
			this.defaultData.description !== this.state.description

		if (this.state.lookupType === "User Identity") {
			condition = condition || this.defaultData.multiSelect !== this.state.multiSelect || this.defaultData.showProfilePicture !== this.state.showProfilePicture || this.defaultData.useDisplayName !== this.state.useDisplayName;
		}

		if (this.state.lookupType === "Number") {
			condition =
				condition ||
				this.defaultData.min !== this.state.min ||
				this.defaultData.max !== this.state.max ||
				this.defaultData.unit !== this.state.unit ||
				this.defaultData.numberType !== this.state.numberType ||
				this.defaultData.unitSide !== this.state.unitSide ||
				this.defaultData.decimalPlace !== this.state.decimalPlace ||
				this.defaultData.useThousandSeparator !== this.state.useThousandSeparator;
		}

		if (this.state.lookupType === "String") {
			condition = condition || this.defaultData.min !== this.state.min || this.defaultData.max !== this.state.max || this.defaultData.pattern !== this.state.pattern;
			if (!this.state.isPatternValid || !this.state.errors.isMinValid || !this.state.errors.isMaxValid) {
				condition = false;
			}
		}

		if (this.state.lookupType === "Picklist String") {

			condition = condition || this.defaultData.picklist !== this.state.picklist || this.defaultData.multiSelect !== this.state.multiSelect;
			if (!this.state.isPicklistProper) {
				condition = false;
			}
			if (this.state.isPicklistEmpty) {
				condition = false;
			}
		}

		if (this.state.lookupType === "DateTime") {

			if (this.state.dateTimeType === "date") {
				condition = condition || this.defaultData.defaultDate !== this.state.defaultDate || this.defaultData.setDefaultDate !== this.state.setDefaultDate;
				if (!this.state.dateError.isDefaultValueValid) {
					condition = false;
				}
			}

			if (this.state.dateTimeType === "time") {
				condition = condition;

				if (this.state.defaultTime && this.defaultData.defaultTime && this.state.defaultTime !== this.defaultData.defaultTime) {
					condition = true;
				} else if (this.state.defaultTime && !this.defaultData.defaultTime) {
					condition = true;
				} else if (this.state.minTime && this.defaultData.minTime && this.state.minTime !== this.defaultData.minTime) {
					condition = true;
				} else if (this.state.minTime && !this.defaultData.minTime) {
					condition = true;
				} else if (this.state.maxTime && this.defaultData.maxTime && this.state.maxTime !== this.defaultData.maxTime) {
					condition = true;
				} else if (this.state.maxTime && !this.defaultData.maxTime) {
					condition = true;
				} else if (this.state.interval !== this.defaultData.interval) {
					condition = true;
				}

				if (!this.state.timeError.isMinValid || !this.state.timeError.isMaxValid || !this.state.timeError.isDefaultValueValid) {
					condition = false;
				}
			}

			if (this.state.dateTimeType === "datetime") {

				condition = condition || this.defaultData.defaultDate !== this.state.defaultDate || this.defaultData.setDefaultDate !== this.state.setDefaultDate;

				if (this.state.defaultTime && this.defaultData.defaultTime && this.state.defaultTime !== this.defaultData.defaultTime) {
					condition = true;
				} else if (this.state.defaultTime && !this.defaultData.defaultTime) {
					condition = true;
				} else if (this.state.minTime && this.defaultData.minTime && this.state.minTime !== this.defaultData.minTime) {
					condition = true;
				} else if (this.state.minTime && !this.defaultData.minTime) {
					condition = true;
				} else if (this.state.maxTime && this.defaultData.maxTime && this.state.maxTime !== this.defaultData.maxTime) {
					condition = true;
				} else if (this.state.maxTime && !this.defaultData.maxTime) {
					condition = true;
				} else if (this.state.interval !== this.defaultData.interval) {
					condition = true;
				}

				if (!this.state.timeError.isMinValid || !this.state.timeError.isMaxValid || !this.state.timeError.isDefaultValueValid) {
					condition = false;
				}

				if (!this.state.dateError.isDefaultValueValid) {
					condition = false;
				}
			}
		}

		if (this.state.lookupType === "State Field") {
			const statefieldValues = this.state.statefield
			const defaultStatefieldValues = this.defaultData.statefield

			let isStatefieldValid = true;

			if (statefieldValues.length === 0 || statefieldValues.length !== defaultStatefieldValues.length) {
				isStatefieldValid = false;
			} else {
				// check if statefield values are empty or not
				for (let i = 0; i < statefieldValues.length; i++) {
					if (statefieldValues[i].name === "" || statefieldValues[i].color === "") {
						isStatefieldValid = false;
						break;
					}
				}

				// compare object name and color with default statefield values
				for (let i = 0; i < statefieldValues.length; i++) {
					if (statefieldValues[i].name !== defaultStatefieldValues[i].name || statefieldValues[i].color !== defaultStatefieldValues[i].color) {
						isStatefieldValid = false;
						break;
					}
				}
			}

			condition = condition || !isStatefieldValid;
		}

		if (this.state.nameError.isValid === false || this.state.statefieldError.isValid === false) {
			condition = false;
		}

		if (condition) {
			this.setState({ disabled: false });
		} else {
			this.setState({ disabled: true });
		}
	};

	handleSubmit = (e) => {
		e.preventDefault();
		this.Save();
	};

	Save = async () => {
		this.setState({
			savingAttributeTemplate: true
		})
		let propertiesData = {
			LookupName: this.state.LookupName.trim(),
			description: this.state.description,
		};

		if (this.state.lookupType === "User Identity") {
			propertiesData.showProfilePicture = this.state.showProfilePicture;
			propertiesData.useDisplayName = this.state.useDisplayName;
			propertiesData.multiSelect = this.state.multiSelect;
		}

		if (this.state.lookupType === "Number") {
			propertiesData.min = this.state.min;
			propertiesData.max = this.state.max;
			propertiesData.numberType = this.state.numberType;
			propertiesData.unit = this.state.unit;
			propertiesData.unitSide = this.state.unitSide;
			propertiesData.decimalPlace = this.state.decimalPlace;
			propertiesData.useThousandSeparator = this.state.useThousandSeparator ? "true" : "false";
		}

		if (this.state.lookupType === "String") {
			propertiesData.min = this.state.min;
			propertiesData.max = this.state.max;
			propertiesData.pattern = this.state.pattern;
		}

		if (this.state.lookupType === "Picklist String") {
			propertiesData.multiSelect = this.state.multiSelect;

			// clear empty item from picklist - ali
			let values = this.state.picklist.split('ɖ')
			values = values.filter(o => o.length > 0)
			values = values.join('ɖ');

			propertiesData.picklist = values;
		}

		if (this.state.lookupType === "DateTime") {
			if (this.state.dateTimeType === "date") {

				propertiesData.defaultDate = this.state.defaultDate;
				propertiesData.setDefaultDate = this.state.setDefaultDate ? "true" : "false";
			}
			if (this.state.dateTimeType === "time") {
				const { minTime, maxTime, defaultTime } = this.state;
				propertiesData.minTime = minTime;
				propertiesData.maxTime = maxTime;
				propertiesData.interval = this.state.interval;
				propertiesData.defaultTime = defaultTime;
			}
			if (this.state.dateTimeType === "datetime") {
				const { minTime, maxTime, defaultTime, defaultDate, setDefaultDate } = this.state;
				propertiesData.defaultDate = defaultDate;
				propertiesData.setDefaultDate = setDefaultDate ? "true" : "false";
				propertiesData.minTime = minTime;
				propertiesData.maxTime = maxTime;
				propertiesData.interval = this.state.interval;
				propertiesData.defaultTime = defaultTime;
			}
		}

		if (this.state.lookupType === "State Field") {
			let values = this.state.statefield
			values = values.filter(o => o.name.trim().length > 0)
			for (let i = 0; i < values.length; i++) {
				if (values[i]._id === undefined) {
					values[i]._id = uuidv4()
				}
				values[i].name = values[i].name.trim()
				values[i].order = parseInt((i + 1) * 10000000000);
			}
			propertiesData['statefield'] = values
		}

		await updateAttributeTemplate(this.state._id, propertiesData);

		this.setState({
			disabled: true,
			nameExists: false,
			savingAttributeTemplate: false,
			validName: true,
			errors: {
				isMinValid: true,
				isMaxValid: true,
				minError: "",
				maxError: "",
			},
			isPicklistProper: true,
		});

		const updatedAttributeTemplate = {
			...this.props.selectedAttribute,
			...propertiesData
		};
		this.defaultData = { ...updatedAttributeTemplate }
		this.props.updateAttribute(this.state._id, updatedAttributeTemplate);
	};

	setDefault = (e) => {
		let data = this.defaultData
		const newState = {
			...data,
			disabled: true,
			nameExists: false,
			nameError: {
				isValid: true,
				message: ""
			},

			errors: {
				isMinValid: true,
				isMaxValid: true,
				minError: "",
				maxError: "",
			},
			isPicklistProper: true,
			isPatternValid: true,
			isPicklistEmpty: false
		};
		this.setState(newState)
	};
}

export default withTranslation([
	"property_template/look_up_detail"
], {
	withRef: true
})(LookupSidebar);
